var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClutch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_166_950)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 18,
    r: 18,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7049 11.6255C28.3933 10.0401 26.6245 8.89791 24.6398 8.35472C22.6552 7.81154 20.5513 7.89381 18.6151 8.59031C16.6789 9.2868 15.0047 10.5636 13.8209 12.2466C12.637 13.9296 12.0011 15.9368 12 17.9944C11.9989 20.0521 12.6325 22.06 13.8144 23.7443C14.9964 25.4286 16.6692 26.7073 18.6046 27.4059C20.54 28.1046 22.6438 28.1892 24.6291 27.6482C26.6143 27.1073 28.3844 25.967 29.6978 24.3831L26.214 21.4943C25.495 22.3614 24.526 22.9855 23.4392 23.2817C22.3524 23.5778 21.2008 23.5315 20.1413 23.149C19.0818 22.7666 18.1661 22.0666 17.519 21.1446C16.872 20.2225 16.5251 19.1234 16.5258 17.9969C16.5264 16.8705 16.8745 15.7717 17.5225 14.8504C18.1706 13.9291 19.0871 13.2302 20.147 12.8489C21.2069 12.4676 22.3587 12.4226 23.4451 12.7199C24.5316 13.0173 25.4998 13.6426 26.2179 14.5104L29.7049 11.6255Z",
    fill: "#7F00E2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 18.0008,
    r: 3.07692,
    fill: "#7F00E2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_166_950",
    x: 0,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_166_950"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_166_950",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClutch);
export default __webpack_public_path__ + "static/media/clutch.a97eaee47cd774ed0a0062e8ed5083f0.svg";
export { ForwardRef as ReactComponent };